<template>
    <div class="min-h-full flex flex-col justify-between">
        <div class="flex justify-start items-center gap-1 w-full">
            <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
            <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
            <p class="text-[18px] laptop:text-[20px] font-semibold font-roboto pl-2 m-0 text-[#333333]">Pay with card
            </p>
        </div>
        <div class="w-full min-h-[90px] flex flex-column justify-start mt-[15px]">
            <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]"
                for="cardholder">Cardholder
                Name<span class="ml-1 text-[#EE5851]">*</span></label>
            <inputComponent ref="cardHolderName" v-model="cardHolderName" name="cardholder" required
                placeholder="Full name on card" length="120" error-message="Invalid Cardholder Name"
                custom-class="!text-[14px] h-[40px] border border-[#E2E5EC] outline-none py-2 px-3 w-full !rounded-[8px] placeholder:text-[#AAAAAA] text-[#333333]" />
        </div>
        <div class="w-full min-h-[90px] flex flex-column justify-start relative">
            <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="cardnumber">Card
                Number<span class="ml-1 text-[#EE5851]">*</span></label>
            <div class="relative">
                <div id="card-number" class="h-[40px] py-[11px] px-3 rounded-[8px] border border-[#E2E5EC]" />
                <!-- Icon on right -->
                <img v-if="cardBrand" :src="require(`../../assets/images/${cardBrand}.png`)"
                    class="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-auto">
            </div>
            <div id="card-number-error" class="" />
        </div>
        <div class="mobile:block laptop:flex gap-3">
            <div class="mobile:w-full laptop:w-1/3 min-h-[90px] flex flex-column justify-start">
                <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="cardexpiry">Card
                    Expiry<span class="ml-1 text-[#EE5851]">*</span></label>
                <div class="relative">
                    <div id="card-expiry" class="h-[40px] py-[11px] px-3 rounded-[8px] border border-[#E2E5EC]" />
                    <div id="card-expiry-error" class="" />
                </div>
            </div>
            <div class="mobile:w-full laptop:w-1/3 min-h-[90px] flex flex-column justify-start">
                <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="cardCVC">Card
                    CVC<span class="ml-1 text-[#EE5851]">*</span></label>
                <div class="relative">
                    <div id="card-cvc" class="h-[40px] py-[11px] px-3 rounded-[8px] border border-[#E2E5EC]" />
                    <div id="card-cvc-error" class="" />
                </div>
            </div>
            <div class="mobile:w-full laptop:w-1/3 min-h-[90px] flex flex-column justify-start">
                <label class="text-[13px] font-normal font-roboto text-[#666666] w-full mb-[6px]" for="zipcode">Zip
                    Code<span class="ml-1 text-[#EE5851]">*</span></label>
                <inputComponent ref="billingZipCode" v-model="billingZipCode" name="zipcode" required
                    placeholder="Zip Code" error-message="Invalid zip code." length="5" type="number"
                    :regex="$constants.ZIP_CODE_REGEX"
                    custom-class="!text-[14px] h-[40px] border border-[#E2E5EC] outline-none py-2 px-3 w-full !rounded-[8px] placeholder:text-[#AAAAAA] text-[#333333]" />
            </div>
        </div>
        <p class="m-0 text-[11px] font-roboto text-[#AAAAAA]">Card details are processed securely. fyxify never stores
            full card numbers.</p>
    </div>
</template>
<script>
import { globals } from "../../main";
import inputComponent from '../../components/partialComponent/inputComponent.vue';
export default {

    components: {
        inputComponent
    },
    props: ["stripe_id"],
    data() {
        return {
            token: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            cardHolderName: null,
            billingZipCode: null,
            cardNumberError: null,
            cardExpiryError: null,
            cardCvcError: null,

            cardNumberValid: false,
            cardExpiryValid: false,
            cardCvcValid: false,
            cardBrand: null
        }
    },

    computed: {
        stripeElements() {
            return this.$stripe.elements({
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap",
                    },
                ],
            });
        },

        validationCheck() {
            if (this.$helper.isEmpty(this.cardHolderName)) return false;
            if (this.$helper.isEmpty(this.billingZipCode) || (this.billingZipCode + "").length < 5) return false;
            if (!this.cardNumberValid) return false
            if (!this.cardExpiryValid) return false
            if (!this.cardCvcValid) return false
            return true;
        },
    },

    watch: {
        'stripe_id': {
            handler(value) {
                if (this.stripe_id) {
                    setTimeout(() => {
                        this.create()
                    }, 50);
                }
            },
            immediate: true,
        },
        validationCheck: {
            handler(value) {
                this.$emit("validation-change", this.validationCheck)
            },
            immediate: true,
        },
    },

    mounted() {

    },

    methods: {
        reset() {
            this.token = null
            this.cardHolderName = null
            this.billingZipCode = null
            document.getElementById('card-number-error').innerHTML = ''
            document.getElementById('card-expiry-error').innerHTML = ''
            document.getElementById('card-cvc-error').innerHTML = ''
            this.destroy()
            this.create()
        },

        create() {
            globals.$loader.show();
            const style = {
                base: {
                    color: '#333333',
                    fontFamily: '"Lato", sans-serif',
                    fontSize: '14px',
                    '::placeholder': {
                        color: '#AAAAAA',
                    },
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a',
                },
            };


            if (this.$stripe == null) {
                this.$stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
                    stripeAccount: this.stripe_id + ""
                })

            }
            this.cardNumber = this.stripeElements.create('cardNumber', {
                style,
                disableLink: true,
            });

            this.cardNumber.mount('#card-number');
            this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
            this.cardExpiry.mount('#card-expiry');
            this.cardCvc = this.stripeElements.create('cardCvc', { style });
            this.cardCvc.mount('#card-cvc');

            this.cardNumber.on("change", (event) => {

                // brand detect
                this.cardBrand = event.brand && event.brand !== "unknown"
                    ? (event.brand == 'visa' ? 'card-icon-1'
                        : event.brand == 'mastercard' ? 'card-icon-2'
                            : event.brand == 'amex' ? 'card-icon-3'
                                : null) : null;

                if (event.error) {
                    this.cardNumberValid = false
                    this.cardNumberError = event.error.message
                } else if (!event.complete) {
                    this.cardNumberValid = false
                    this.cardNumberError = "Card number is incomplete"
                } else {
                    this.cardNumberValid = true
                    this.cardNumberError = null
                }
                this.displayError(event, "card-number-error")
            })

            this.cardExpiry.on("change", (event) => {
                if (event.error) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = event.error.message
                } else if (!event.complete) {
                    this.cardExpiryValid = false
                    this.cardExpiryError = "Card number is incomplete"
                } else {
                    this.cardExpiryValid = true
                    this.cardExpiryError = null
                }
                this.displayError(event, "card-expiry-error")
            })

            this.cardCvc.on("change", (event) => {
                if (event.error) {
                    this.cardCvcValid = false
                    this.cardCvcError = event.error.message
                } else if (!event.complete) {
                    this.cardCvcValid = false
                    this.cardCvcError = "Card number is incomplete"
                } else {
                    this.cardCvcValid = true
                    this.cardCvcError = null
                }
                this.displayError(event, "card-cvc-error")
            })

            globals.$loader.hide();
        },

        displayError(event, elementId) {
            let errorContainer = document.getElementById(elementId);
            if (event.error) {

                errorContainer.innerHTML = `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${event.error.message}</p>`
                if (elementId === "card-number-error") this.cardNumberError = event.error.message;
                if (elementId === "card-expiry-error") this.cardExpiryError = event.error.message;
                if (elementId === "card-cvc-error") this.cardCvcError = event.error.message;
            } else {
                errorContainer.innerHTML = ''
                if (elementId === "card-number-error") this.cardNumberError = null;
                if (elementId === "card-expiry-error") this.cardExpiryError = null;
                if (elementId === "card-cvc-error") this.cardCvcError = null;
            }
        },

        destroy() {
            this.cardNumber.destroy();
            this.cardExpiry.destroy();
            this.cardCvc.destroy();
        },

        checkValidation() {
            let isValid = true;

            const refsToValidate = [
                this.$refs.cardHolderName,
                this.$refs.billingZipCode,
            ];
            let firstInvalidRef = null;
            // Validate each ref
            for (const ref of refsToValidate) {
                if (ref?.validate?.()) {
                    if (!firstInvalidRef) firstInvalidRef = ref;
                }
            }
            // Cardholder Name
            if (firstInvalidRef) {
                isValid = false;
            }
            // Stripe elements errors
            if (this.cardNumberError) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardNumberError}</p>`;
                isValid = false;
            }
            if (this.cardExpiryError) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardExpiryError}</p>`;
                isValid = false;
            }
            if (this.cardCvcError) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">${this.cardCvcError}</p>`;
                isValid = false;
            }
            if (!this.cardNumberError && !this.cardNumber._complete) {
                document.getElementById('card-number-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Card number field is required</p>`;
                isValid = false;
            }
            if (!this.cardExpiryError && !this.cardExpiry._complete) {
                document.getElementById('card-expiry-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">Expiry date field is required</p>`;
                isValid = false;
            }
            if (!this.cardCvcError && !this.cardCvc._complete) {
                document.getElementById('card-cvc-error').innerHTML =
                    `<p class="text-red-500 text-xs mt-1 mb-0 leading-none">CVC field is required</p>`;
                isValid = false;
            }

            return isValid;
        },

        async getData() {
            const { token, error } = await this.$stripe.createToken(this.cardNumber)
            return { token, error }
        }

    },

}
</script>